import { Component, EventEmitter, Input, Output } from '@angular/core';
import { REPORT_INVOKE_ACTION } from 'src/app/constants/report.constants';
import { Configuration } from 'src/assets/Configuration';

@Component({
  selector: 'app-report-viewer-modal',
  standalone: false,
  templateUrl: './report-viewer-modal.component.html',
  styleUrl: './report-viewer-modal.component.scss',
})
export class ReportViewerModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() title: string | null = null;
  @Input() reportUrl: string = '';

  @Input() width: string | number = '1000px';
  @Input() height: string | number = '90%';

  hostApiUrl!: string;
  invokeAction = REPORT_INVOKE_ACTION;

  ngOnInit() {
    this.hostApiUrl = Configuration.getApiBaseUrl();
  }

  onClose(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }

  onBeforeRender(event: any) {
    const viewer = event.sender;
    const model = viewer.GetPreviewModel();

    if (model && model.reportPreview) {
      model.reportPreview.zoom = 1; // 100%
    }
  }
}